module.exports = __webpack_public_path__ + "img/Stratagem.49c2f554.png";